export default "/assets/images/mila-room-showcase-sm-02.cfc3d828ae820bf8.jpg";